module.exports = __webpack_public_path__ + "img/体育公益_2@2x.b4826536.png";